/**
 * Google Analytics 4 (GA4) via react-ga4.
 * Measurement ID: G-R94TTZNZNC (set in GA; can override with REACT_APP_GA_MEASUREMENT_ID).
 */

import ReactGA from "react-ga4";

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "G-R94TTZNZNC";

let initialized = false;

export function initAnalytics(): void {
  if (typeof window === "undefined" || !MEASUREMENT_ID) return;
  if (initialized) return;

  try {
    ReactGA.initialize(MEASUREMENT_ID, {
      gaOptions: {
        send_page_view: true,
      },
    });
    initialized = true;
  } catch (e) {
    console.warn("GA4 init failed:", e);
  }
}

export function trackPageView(path: string, title?: string): void {
  if (!initialized) return;
  try {
    ReactGA.send({
      hitType: "pageview",
      page: path,
      title: title || document.title,
    });
  } catch {
    // no-op
  }
}

export function trackEvent(
  name: string,
  params?: { [key: string]: string | number | boolean }
): void {
  if (!initialized) return;
  try {
    ReactGA.gtag("event", name, params);
  } catch {
    // no-op
  }
}

export const Analytics = {
  getStarted: () => trackEvent("cta_click", { location: "hero", label: "get_started" }),
  seeHowItWorks: () => trackEvent("cta_click", { location: "hero", label: "see_how_it_works" }),
  learnMore: () => trackEvent("cta_click", { location: "middle_block", label: "learn_more" }),
  aboutCta: () => trackEvent("cta_click", { location: "about", label: "see_how_it_works" }),
  formSubmit: () => trackEvent("form_submit", { form: "contact_signup" }),
  navClick: (label: string) => trackEvent("nav_click", { link: label }),
  languageSwitch: (lang: string) => trackEvent("language_switch", { language: lang }),
};

export const isAnalyticsEnabled = (): boolean => initialized;
